module.exports = __webpack_public_path__ + "img/product-preview-64.8077200.png";